"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSkanCVEventNameMap = createSkanCVEventNameMap;
exports.createMultiCampaignSkanCVEventNameMap = createMultiCampaignSkanCVEventNameMap;
exports.hasFineCVSplit = hasFineCVSplit;
/**
 * Creates a lookup map from conversion value to event name for a single campaign
 */
function createSkanCVEventNameMap(postbackConversionValues) {
    const eventNameMap = {};
    if (!postbackConversionValues) {
        return eventNameMap;
    }
    postbackConversionValues.forEach((sequence) => {
        var _a;
        (_a = sequence.values) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            // Only map fine conversion values (numeric strings 0-63)
            if (item.conversionValue && !isNaN(parseInt(item.conversionValue))) {
                eventNameMap[item.conversionValue] = item.eventName;
            }
        });
    });
    return eventNameMap;
}
/**
 * Creates a lookup map from conversion value to event name for multiple campaigns
 * Takes into account campaign filter to only consider filtered campaigns
 */
function createMultiCampaignSkanCVEventNameMap(campaigns, campaignFilter) {
    var _a;
    if (!campaigns.length) {
        return {};
    }
    const filteredCampaigns = (campaignFilter === null || campaignFilter === void 0 ? void 0 : campaignFilter.length)
        ? campaigns.filter((campaign) => campaignFilter.includes(campaign.id) ||
            campaignFilter.includes(campaign.name))
        : campaigns;
    if (!filteredCampaigns.length) {
        return {};
    }
    // Get the first filtered campaign's SKAN CV map as reference
    const referenceMap = createSkanCVEventNameMap((_a = filteredCampaigns === null || filteredCampaigns === void 0 ? void 0 : filteredCampaigns[0]) === null || _a === void 0 ? void 0 : _a.postbackConversionValues);
    // Check if all filtered campaigns have the same SKAN CV map
    for (let i = 1; i < filteredCampaigns.length; i++) {
        const currentMap = createSkanCVEventNameMap(filteredCampaigns[i].postbackConversionValues);
        // Compare maps
        const referenceKeys = Object.keys(referenceMap).sort();
        const currentKeys = Object.keys(currentMap).sort();
        if (referenceKeys.length !== currentKeys.length ||
            !referenceKeys.every((key) => referenceMap[key] === currentMap[key])) {
            return {}; // Different maps, don't show event names
        }
    }
    return referenceMap;
}
/**
 * Checks if a report has FineCV split (CONVERSION_VALUE in splits)
 */
function hasFineCVSplit(splits) {
    return splits.some((split) => split.id === "CONVERSION_VALUE");
}
